import { render } from "./TextBubble.vue?vue&type=template&id=1129ab5c&scoped=true"
import script from "./TextBubble.vue?vue&type=script&lang=js"
export * from "./TextBubble.vue?vue&type=script&lang=js"

import "./TextBubble.vue?vue&type=style&index=0&id=1129ab5c&scoped=true&lang=css"

import exportComponent from "P:\\roboworks\\easyros\\easyros\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1129ab5c"]])

export default __exports__